import React, { Fragment, useEffect, useState } from "react";
import Modal from "components/utils/Modal";
import BinLocationService from "services/BinLocationService";
import PartNameService from "services/PartNameService";

const CreatePartName = ({ open, onCloseModal, onCreated }) => {
  const [block, setBlock] = useState(false);

  const [data, setData] = useState({
    name: "",
    part_number: "",
    description: "",
  });

  const handleChange = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    setBlock(false);

    setData({
      ...data,
      [name]: value,
    });
  };

  const addPartName = async () => {
    setBlock(true);
    await PartNameService.create(data);
    setData({
      name: "",
      part_number: "",
      description: "",
    });
    onCreated();
    onCloseModal();
    setBlock(false);
  };

  return (
    <div>
      <Modal
        open={open}
        onCloseModal={onCloseModal}
        title={<>Add Part Name</>}
        body={
          <>
            <div className="form-group mt-5">
              <label className="required form-label">Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Part name"
                name="name"
                id="name"
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-5">
              <label className="required form-label">Part Number</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Part number"
                name="part_number"
                id="part_number"
                onChange={handleChange}
              />
            </div>

            <div className="form-group mt-5">
              <label className="form-label">Description</label>
              <textarea
                rows="3"
                type="text"
                className="form-control"
                placeholder="Enter  Description"
                name="description"
                id="description"
                onChange={handleChange}
              />
            </div>

            <button
              type="reset"
              className="btn btn-primary mr-2 mt-5"
              style={{ marginRight: "1rem" }}
              onClick={addPartName}
              disabled={block}
            >
              Create
            </button>
            <button
              type="reset"
              className="btn btn-secondary  mt-5 "
              onClick={onCloseModal}
            >
              Cancel
            </button>
          </>
        }
      />
    </div>
  );
};

export default CreatePartName;
